// @flow

import type { Amount, CurrencyCode } from '@tectonics/prs/money';
import type { InstalmentsPlan, Receipt } from '@tectonics/prs/receipts';
import type { ApiInstalment } from './types';

export function normalizeInstalmentsPlan(
  instalmentsPlan: ImmutableArray<ApiInstalment>,
  currencyCode: CurrencyCode,
): { [string]: Receipt} {

  return instalmentsPlan.reduce((receipts, apiInstalment): { [string]: Receipt } => {
    const amount_ext = getTotalAmount(currencyCode, apiInstalment);
    const amount_local_base = getTotalAmount(currencyCode, apiInstalment);
    const amount_local_total = getTotalAmount(currencyCode, apiInstalment);

    const fx = { from: currencyCode, to: currencyCode, rate: '1.000' };
    const instalments_plan = buildReceiptInstalmentsPlan(currencyCode, apiInstalment);
    const local_taxes = [];

    receipts[apiInstalment.quantity.toString()] = {
      fx,
      amount_ext,
      amount_local_base,
      amount_local_total,
      local_taxes,
      instalments_plan,
    };

    return receipts;
  }, {});
}

function getTotalAmount(currencyCode: CurrencyCode, apiInstalment: ApiInstalment): Amount {
  return [currencyCode, apiInstalment.totalAmount];
}

function buildReceiptInstalmentsPlan(currencyCode: CurrencyCode, apiInstalment: ApiInstalment): InstalmentsPlan {
  return {
    instalments: apiInstalment.quantity,
    amount_partial_first: getInstalmentAmount(currencyCode, apiInstalment),
    amount_partial_other: getInstalmentAmount(currencyCode, apiInstalment),
  };
}

function getInstalmentAmount(currencyCode: CurrencyCode, apiInstalment: ApiInstalment): Amount {
  return [currencyCode, apiInstalment.instalmentAmount.toString()];
}
